import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HamburgerMenuComponent } from '../shared-components/hamburger-menu/hamburger-menu.component';
import { UserInfoDialogComponent } from '../shared-components/user-info-dialog/user-info-dialog.component';

@Component({
  selector: 'four-oh-three',
  imports: [HamburgerMenuComponent, UserInfoDialogComponent],
  
  templateUrl: './four-oh-three.component.html',
  styleUrl: './four-oh-three.component.scss'
})
export class FourOhThreeComponent {
  protected readonly support = environment.support;
}
